'use client'
import React, { useState, useEffect } from 'react';
import portfolioData from "@/public/data/staticdata/portfolio.json";
import ImageHoverShowGif from '../ImageHoverShowGif';

interface PortfolioItem {
  id: number;
  title: string;
  slug: string;
  image: string;
  tag: string;
  date: string;
}

interface DynamicPortfolioProps {
  color: string;
  keyword: string;
}

// const DynamicPortfolio: React.FC<DynamicPortfolioProps> = ({ color, keyword }) => {
//   const fetchPortfolio = (): PortfolioItem[] => {
//     const keywords = keyword.toLowerCase().split(',').map(k => k.trim());
//     // console.log("dynamic portfolio keywords =>",keywords);

//     return portfolioData
//       .filter(item => keywords.some(k => item.tag.toLowerCase().includes(k)))
//       .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
//       .reduce<PortfolioItem[]>((acc, item) => {
//         const matches = keywords.filter(k => item.tag.toLowerCase().includes(k));
//         if (matches.length && acc.length < 3) {
//           acc.push(item);
//         }
//         return acc;
//       }, [])
//       .slice(0, 3);
//   };

const DynamicPortfolio: React.FC<DynamicPortfolioProps> = ({ color, keyword }) => {
  const [portfolios, setPortfolios] = useState<PortfolioItem[]>([]);

  useEffect(() => {
    const fetchPortfolio = (): PortfolioItem[] => {
      const keywords = keyword.toLowerCase().split(',').map(k => k.trim());

      let filtered = portfolioData
        .filter(item => keywords.some(k => item.tag.toLowerCase().includes(k)))
        .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

      if (filtered.length < 3) {
        const fallback = portfolioData
          .filter(item => keywords.some(k => item.slug.toLowerCase().includes(k)))
          .slice(0, 3 - filtered.length);
        filtered = [...filtered, ...fallback];
      }

      // **Sort based on the exact keyword order**
      filtered.sort((a, b) => {
        return keywords.indexOf(a.slug.toLowerCase()) - keywords.indexOf(b.slug.toLowerCase());
      });

      return filtered.slice(0, 3);
    };

    setPortfolios(fetchPortfolio());
  }, [keyword]);

  // const portfolios = fetchPortfolio();
  // console.log("portfolios =>", portfolios);

  return (
    <>
      {/* Our Work area start blog__animation*/}
      <section className={`blog__area-6 ${color}`}>
        <div className="container g-  pt-5 pb-4">
          <div className="text-center py-2">
            <span className="sec-subtile-6">Works</span>
          </div>
          <div className="row pb-5">
            <div className="col-xxl-8 col-xl-7 col-lg-6 col-md-6">
              <div className="sec-title-wrapper !pt-0">
                <h2 className="sec-title-2 !pt-0">Our Work</h2>
              </div>
            </div>
            <div className="col-xxl-4 col-xl-5 col-lg-6 col-md-6">
              <div className="blog__text">
                <p>
                  We work with global brands and agencies, using flat design and digital technology.
                  <br />
                  We make software for startups, businesses, and brands. See our work.{" "}
                </p>
              </div>
            </div>
          </div>

          {/* Dynamic rendering of portfolio items */}
          <div className="row reset-grid">
            <ImageHoverShowGif item={portfolios.slice(0, 3) as any} />
          </div>
        </div>
      </section>
      {/* Our Work area end */}
    </>
  );
};

export default DynamicPortfolio;
